import React, { useState, useEffect, useContext } from "react";
import peij from "../../../services/peij";
import { formatDateTime } from "../../../helpers/helpers";
import AppContext from "../../../container/context";
import { CircularProgress } from "@mui/material";
import Form from "../../../components/form";

const Token = (props) => {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [tokenPagamento, setTokenPagamento] = useState({});
  const [tokenPagamentoCodigo] = useState(props.match.params.codigo);

  useEffect(() => {
    carregarUsuarioToken();
  }, []);

  const carregarUsuarioToken = () => {
    setCarregando(true);

    peij
      .post("assinaturas/carregarUsuarioTokenPagamento", {
        tokenPagamentoCodigo,
      })
      .then((tokenPagamento) => {
        tokenPagamento.valor = (tokenPagamento.valor / 100).toFixed(2);
        tokenPagamento.link = `https://checkout.inglesjuntos.com.br/purchase/${tokenPagamento.codigo}`;

        setTokenPagamento(tokenPagamento);
        setCarregando(false);
      })
      .catch((e) => {
        console.log("e", e);
        notification("error", "Não foi possível validar o usuário: " + e);
      });
  };

  const salvar = (form) => {
    const tokenSalvar = {
      codigo: tokenPagamento.codigo,
      valor: (form.valor * 100).toFixed(0),
      maxParcelas: form.maxParcelas,
      duracaoAssinatura: form.duracaoAssinatura,
      validade: form.validade,
    };

    peij
      .post("assinaturas/editarTokenPagamento", tokenSalvar)
      .then((result) => {
        if (result.ok) {
          notification("success", "Token editado com sucesso!");
          return props.history.goBack();
        }
        notification(
          "error",
          "Não foi possível editar o token. Verifique as informações e tente novamente."
        );
      })
      .catch((err) => {
        console.log(err);
        notification(
          "error",
          "Não foi possível editar o token. Verifique as informações."
        );
      });
  };

  const camposToken = (tokenPagamento) => {
    return {
      usuarioNome: {
        label: "Nome do usuário",
        type: "text",
        value: tokenPagamento.usuarioNome,
        readOnly: false,
        space: 6,
      },
      usuarioEmail: {
        label: "Email",
        type: "text",
        value: tokenPagamento.usuarioEmail,
        readOnly: false,
        space: 6,
      },
      valor: {
        label: "Valor R$",
        type: "number",
        value: tokenPagamento.valor,
        space: 3,
        required: true,
      },
      maxParcelas: {
        label: "Máximo de parcelas",
        type: "number",
        value: tokenPagamento.maxParcelas,
        space: 3,
        required: true,
      },
      duracaoAssinatura: {
        label: "Duração da assinatura (meses)",
        type: "number",
        value: tokenPagamento.duracaoAssinatura,
        space: 3,
        required: true,
      },
      validade: {
        label: "Validade do link de pagamento",
        type: "date",
        value: tokenPagamento.validade
          ? formatDateTime(tokenPagamento.validade, "Y-M-D")
          : null,
        required: true,
        space: 3,
      },
      labelLink: {
        label: "Link para pagamento",
        type: "component",
        value: <h4>Link para pagamento</h4>,
      },
      link: {
        label: "Link para pagamento",
        type: "component",
        value: (
          <a
            target="_blank"
            href={tokenPagamento.link}
            style={{ marginBottom: 30 }}
            rel="noreferrer"
          >
            {tokenPagamento.link}
          </a>
        ),
      },
    };
  };

  const fToken = {
    title: tokenPagamento.utilizacao
      ? "Token de pagamento"
      : "Editar token de pagamento",
    form: camposToken(tokenPagamento),
    submit: tokenPagamento.utilizacao
      ? undefined
      : {
          label: "Salvar",
          action: salvar,
        },
    close: {},
    history: props.history,
  };

  return (
    <div>{carregando ? <CircularProgress /> : <Form formData={fToken} />}</div>
  );
};

export default Token;
